// node modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import Skeleton from 'react-loading-skeleton';

// app modules: components
import Heading from 'components/Heading';

// app modules: services
import formatter from 'services/formatter';

// assets
import CssGeneralHeader from './GeneralHeader.scss';

const tagRegex = tagName => new RegExp(`<(\\/)?${tagName}[^>]*>`, 'g');
const REGEX = {
  TITLE_TAG: tagRegex('title'),
};

class GeneralHeader extends Component {
  static propTypes = {
    leftComponent: PropTypes.element,
    title: PropTypes.string,
    titleRaw: PropTypes.arrayOf(PropTypes.string),
    subtitle: PropTypes.string,
    subtitleLang: PropTypes.string,
    subtitleRaw: PropTypes.arrayOf(PropTypes.string),
    rightComponent: PropTypes.element,
    displayType: PropTypes.string.isRequired,
  };

  static defaultProps = {
    leftComponent: null,
    title: '',
    titleRaw: [],
    subtitle: '',
    subtitleLang: '',
    subtitleRaw: [],
    rightComponent: null,
  };

  static renderTitle(title, titleRaw, withSkeleton) {
    if (titleRaw && titleRaw.length) {
      const xml = titleRaw
        .map(titlePart => titlePart.replace(REGEX.TITLE_TAG, '<$1span>'))
        .join(' ');
      const HTML = formatter.xml.toHTML(`<span>${xml}</span>`, false);
      formatter.xml.internalizeLinks(HTML);

      if (HTML.getElementsByTagName('i').length) {
        // The title contains italics, so we'll switch styles (Bebas Neue isn't good for italics)
        HTML.setAttribute('class', 'general-header__title-with-style');
      }

      // eslint-disable-next-line react/no-danger
      return <span dangerouslySetInnerHTML={{ __html: HTML.toString() }} />;
    }
    if (title) {
      return title;
    }
    if (withSkeleton) {
      return <Skeleton width="320px" />;
    }
    return null;
  }

  render() {
    const {
      leftComponent,
      title,
      titleRaw,
      subtitle,
      subtitleRaw,
      rightComponent,
      displayType,
      subtitleLang,
    } = this.props;

    if (displayType === 'desktop') {
      return (
        <header className="general-header">
          <div className="general-header__list general-header__list--row">
            <div className="general-header__item">{leftComponent}</div>

            <div className="general-header__item general-header__item--main">
              <Heading level={1} className="heading--size-32">
                {GeneralHeader.renderTitle(title, titleRaw, true)}
              </Heading>
              {subtitle && subtitle.length ? (
                <Heading level={2} subtitleLang={subtitleLang} className="general-header__subtitle">
                  {GeneralHeader.renderTitle(subtitle, subtitleRaw, false)}
                </Heading>
              ) : null}
            </div>

            <div className="general-header__item">{rightComponent}</div>
          </div>
        </header>
      );
    }
    return (
      <header className="general-header">
        <div className="general-header__list general-header__list--column">
          <div className="general-header__item general-header__item--main">
            <Heading level={1} className="heading--size-32">
              {GeneralHeader.renderTitle(title, titleRaw, true)}
            </Heading>
            <Heading level={2} subtitleLang={subtitleLang} className="general-header__subtitle">
              {GeneralHeader.renderTitle(subtitle, subtitleRaw, false)}
            </Heading>
          </div>
        </div>

        <div className="general-header__list general-header__list--row">
          <div className="general-header__item">{leftComponent}</div>
          <div className="general-header__item">{rightComponent}</div>
        </div>
      </header>
    );
  }
}

const mapStateToProps = state => ({
  displayType: state.dimensions.displayType,
});

export default connect(
  mapStateToProps,
  null,
)(withStyles(CssGeneralHeader)(GeneralHeader));
